import { type BundleMachineGuard, type SelectionParams } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether the product is still waiting on its add, so reports that arrive
 * after its deadline are dropped.
 */
export const checkIfProductInFlight: BundleMachineGuard<SelectionParams> = (guardArgs, params) => {
  const { context } = guardArgs;
  const { selectionId } = params;

  return context.productAdds.inFlight.includes(selectionId);
};
